<template>
    <div class="wrap-content app-access-page">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-5 filter-title-section">
                    <h2>Webhooks</h2>
                </div>
                <div class="col-md-7 text-right">
                    <div class="row">
                        <div class="col-md-6 col-xs-12">
                            <div class="form-group search-input">
                                <i class="icon-search"></i>
                                <b-form-input
                                    v-model="query.keyword"
                                    :placeholder="'Search'"
                                    autocomplete="no"
                                    @keyup.enter="applySearch('search')"
                                ></b-form-input>
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-12 filter-btn-section">
                            <div class="row">
                                <div class="col-md-4">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="applySearch('search')"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div class="col-md-8">
                                    <b-button
                                        v-b-modal.add-webhook-popup
                                        class="btn secondary-add-btn"
                                        variant="secondary"
                                        type="submit"
                                        :class="{
                                            'button-disabled':
                                                !hasScopes('manage-webhooks'),
                                        }"
                                    >
                                        <span class="btn-text"
                                            >+ Add Webhook</span
                                        >
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- user management table -->
        <div
            :class="[
                'table-section',
                'tablet-table-xs-min-width',
                'mobile-table-responsive-lg',
                {
                    'overflow-hidden': !items.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                no-local-sorting
                :items="items"
                :fields="webhookRecords"
                class="user-roles-table"
                @sort-changed="sortingChanged"
            >
                <template slot="title" slot-scope="data">
                    {{ data.item.title }}
                </template>
                <template slot="endpointUrl" slot-scope="data">
                    {{ data.item.endpointUrl }}
                </template>
                <template slot="description" slot-scope="data">
                    {{ data.item.description }}
                </template>
                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.item.status"></base-status>
                </template>
                <!-- action slot -->
                <template slot="action" slot-scope="data">
                    <div
                        :class="[
                            'action-review',
                            {
                                disabled: !hasScopes('manage-webhooks'),
                            },
                        ]"
                    >
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-webhook-popup')
                            "
                        ></base-action>
                        <!-- if action archive -->
                        <base-action
                            v-if="data.item.status == 'active'"
                            icon="icon-trash"
                            label="Archive"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('archive-popup')
                            "
                        ></base-action>
                        <!-- if action activate -->
                        <base-action
                            v-if="data.item.status == 'archived'"
                            icon="icon-done"
                            label="Activate"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('activate-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="items.length == 0 && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="items.length == 0 && !showPageLoader"
            ></base-no-record-found>
        </div>
        <pagination
            v-if="!showPageLoader"
            ref="pagination"
            :pagination="pagination"
            @pagination-changed="paginationChanged"
            @button-clicked-previous="applySearch('previous')"
            @button-clicked-next="applySearch('next')"
        ></pagination>
        <add-webhook-popup></add-webhook-popup>
        <archive-popup
            ref="archive-popup"
            record-type="webhook"
            @update-status="updateStatus"
        ></archive-popup>
        <activate-popup
            ref="activate-popup"
            record-type="webhook"
            @update-status="updateStatus"
        ></activate-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import addWebhookPopup from '@/components/popups/AddWebhookPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'
import pagination from '@/components/Pagination.vue'
import activatePopup from '@/components/popups/ActivatePopup.vue'
import Resource from '@/api/resource'
const apiResource = new Resource('access-control/webhooks/')

export default {
    components: {
        addWebhookPopup,
        archivePopup,
        pagination,
        activatePopup,
    },

    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */

    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            query: {
                keyword: '',
                sortOrder: '',
                sortBy: '',
                startAt: 1,
                perPage: 10,
                dataSegmentId: localStorage.getItem('dataSegmentId'),
            },
            webhookRecords: [],
            items: [],
            showPageLoader: true,
            pagination: {},
        }
    },

    computed: {
        ...mapGetters([
            'webhooksFields',
            'webhooksList',
            'selectedItem',
            'reload',
            'loading',
            'hasScopes',
        ]),
    },
    watch: {
        reload(value) {
            if (value) {
                this.items = []
                this.query.startAt = 1
                this.getRecords()
            }
        },
    },
    mounted() {
        this.getRecords()
    },

    methods: {
        async getRecords() {
            console.log('this.webhooksFields', this.webhooksFields)
            this.webhookRecords = this.webhooksFields
            this.showPageLoader = true
            let { data } = await apiResource.list(this.query)
            console.log('------------', data)
            this.pagination = data.pagination
            this.pagination.totalRecords = data.data.length
            this.pagination.perPage = this.query.perPage
            this.items = data.data
            this.showPageLoader = false
            this.$store.commit('setLoading', false)
        },

        sortingChanged(ctx) {
            this.query.sortBy = ctx.sortBy
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.getRecords()
        },

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        },

        async updateStatus(status) {
            let params = {
                id: this.selectedItem._id,
                status: status,
                title: this.selectedItem.title,
                description: this.selectedItem.description,
                endpointUrl: this.selectedItem.endpointUrl,
            }
            await this.$store.dispatch('updateWebhook', params)
        },
        paginationChanged(type) {
            const perPage = type || 10
            this.query.perPage = perPage

            this.getRecords()
        }, // End of paginationChanged() method

        applySearch(type) {
            if (type && type == 'next') {
                this.query.startAt = this.pagination.next
            }

            if (type && type == 'previous') {
                this.query.startAt = this.pagination.current - 1
            }

            if (type && type == 'search') {
                this.query.startAt = 1
            }

            this.items = []
            this.showPageLoader = true
            if (type && type == 'search') {
                this.$store.commit('setLoading', true)
            }

            this.getRecords()
        },
    },
}
</script>
